import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@shadcn-in-nx/ui/card";

export default function BreakdownChart({ title, items, total, onSelect, activeValue }) {
    if (!items?.length) return null;

    const max = items[0]?.count || 1;

    return (
        <Card>
            <CardHeader className="pb-3">
                <CardTitle className="text-base">{title}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-2">
                {items.map((item) => {
                    const pct = total > 0 ? ((item.count / total) * 100).toFixed(1) : 0;
                    const barWidth = max > 0 ? (item.count / max) * 100 : 0;
                    const isActive = activeValue === item.name;

                    return (
                        <button
                            key={item.name}
                            onClick={() => onSelect(item.name)}
                            className={`w-full text-left rounded-md p-2 transition-colors ${
                                isActive
                                    ? "bg-primary/10 ring-1 ring-primary"
                                    : "hover:bg-muted"
                            }`}
                        >
                            <div className="flex items-center justify-between mb-1">
                                <span className="text-sm font-medium truncate mr-2">
                                    {item.name}
                                </span>
                                <span className="text-sm text-muted-foreground shrink-0">
                                    {item.count} ({pct}%)
                                </span>
                            </div>
                            <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                                <div
                                    className="h-full bg-primary rounded-full transition-all duration-300"
                                    style={{ width: `${barWidth}%` }}
                                />
                            </div>
                        </button>
                    );
                })}
            </CardContent>
        </Card>
    );
}
